import { motion } from "framer-motion";
import "./Footer.scss";

const Footer = ({ text, type = "default" }) => {
  return (
    <div className="footer" data-scroll-section>
      <motion.div
        className="circle"
        animate={{ rotate: 180 }}
        transition={{ repeat: Infinity, repeatType: "reverse", duration: 5 }}
      >
        <div
          className="logo"
          style={
            type === "default"
              ? { backgroundImage: `url(assets/tt.gif)` }
              : type === "differ"
              ? { backgroundImage: `url(assets/lo.gif)` }
              : { backgroundImage: `url(assets/cu.gif)` }
          }
        ></div>
        <div className="text">
          {[...text].map((letter, index) => (
            <span key={index}>{letter}</span>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Footer;
